import { createContext, useContext } from "react";
import type { FeedbackType } from "./api";

export interface OpenFeedback {
  type?: FeedbackType;
  title?: string;
  body?: string;
  /** The identifier of a failed request the report is about — the error screen and the 5xx toast. */
  requestId?: string;
}

export interface FeedbackDialogApi {
  open: (options?: OpenFeedback) => void;
}

export const FeedbackDialogContext = createContext<FeedbackDialogApi | null>(null);

/** Null outside the provider, or for somebody who may not send a report — then there is no button. */
export function useFeedbackDialog(): FeedbackDialogApi | null {
  return useContext(FeedbackDialogContext);
}
